<p-blockUI [blocked]="loading === true" />
@if (!this._deviceService.isMobile()) {
  <div class="ui-g ui-fluid" id="contact-action-buttons">
    <div class="buttons">
      <div id="business-units-wrapper">
        <app-business-unit-filter
          (selectedBusinessUnitsChanged)="handleBusinessUnitChange()"
          #buFilter
        />
      </div>
      @if (canUserAddContact()) {
        <button
          pButton
          class="width-eighty"
          label="{{ 'COMMON.LABEL.BUTTONS.NEW' | translate }}"
          icon="fa fa-fw fa-plus"
          (click)="addNewUser()"
        ></button>
      }
      <button
        pButton
        class="refresh-button width-twenty"
        icon="fa fa-fw fa-refresh"
        (click)="refresh()"
      ></button>
      <button
        pButton
        label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
        icon="fa fa-fw fa-eraser"
        (click)="clearScreen()"
      ></button>
    </div>
  </div>
}

@if (this._deviceService.isMobile()) {
  <p-panel
    [showHeader]="true"
    header="Filters"
    [toggleable]="true"
    [(collapsed)]="mobileFilterCollapsed"
  >
    <div class="ui-g ui-fluid">
      <div class="ui-g-12">
        <app-contact-mobile-filter
          (mobileFilterEvent)="mobileFilter($event)"
          [showMobileFilter]="true"
        />
      </div>
    </div>
  </p-panel>
}

<app-progress-spinner [enabled]="!elements" />
<div [style.display]="!elements ? 'none' : ''">
  <app-general-grid
    [values]="elements"
    [columns]="columns"
    [loading]="loading"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [filterable]="true"
    [screenName]="screenName"
    [lazy]="true"
    (lazyLoad)="lazyLoad($event)"
    [includeExportCSV]="false"
    (changeViewEvent)="changeViewEvent($event)"
    [scrollHeight]="scrollHeight"
    [usePaginator]="true"
    [rowsPerPageOptions]="[50, 100, 200]"
    #grid
  />
</div>
